// DivineCart Logo — custom crafted SVG mark + wordmark
// The mark: a stylized diya (oil lamp) with flame, evoking devotion, warmth, and sacred light.
// Palette matches the brand: saffron → gold gradient on maroon accents.

export function DivineCartMark({ size = 40, className = "" }) {
  return (
    <svg width={size} height={size} viewBox="0 0 64 64" xmlns="http://www.w3.org/2000/svg" className={className} aria-hidden="true">
      <defs>
        <linearGradient id="dcMarkBg" x1="0" y1="0" x2="1" y2="1">
          <stop offset="0%" stopColor="#F47920" />
          <stop offset="55%" stopColor="#D4772A" />
          <stop offset="100%" stopColor="#800000" />
        </linearGradient>
        <linearGradient id="dcFlame" x1="0" y1="1" x2="0" y2="0">
          <stop offset="0%" stopColor="#FFCF6B" />
          <stop offset="60%" stopColor="#FFE9AC" />
          <stop offset="100%" stopColor="#FFFFFF" />
        </linearGradient>
        <radialGradient id="dcGlow" cx="50%" cy="55%" r="50%">
          <stop offset="0%" stopColor="#FFE9AC" stopOpacity="0.7" />
          <stop offset="100%" stopColor="#FFE9AC" stopOpacity="0" />
        </radialGradient>
      </defs>

      {/* Rounded coin */}
      <circle cx="32" cy="32" r="30" fill="url(#dcMarkBg)" />
      <circle cx="32" cy="32" r="30" fill="none" stroke="#D4AF37" strokeOpacity="0.55" strokeWidth="1" />

      {/* Soft glow behind flame */}
      <circle cx="32" cy="26" r="16" fill="url(#dcGlow)" />

      {/* Flame */}
      <path
        d="M32 12 C 36 20, 40 24, 40 30 C 40 36, 36.5 40, 32 40 C 27.5 40, 24 36, 24 30 C 24 24, 28 20, 32 12 Z"
        fill="url(#dcFlame)"
      />
      {/* Inner flame highlight */}
      <path
        d="M32 20 C 34 25, 35 28, 35 31 C 35 34, 33.5 36, 32 36 C 30.5 36, 29 34, 29 31 C 29 28, 30 25, 32 20 Z"
        fill="#FFB84D"
        opacity="0.75"
      />

      {/* Diya body */}
      <path
        d="M14 44 Q 32 58, 50 44 L 46 48 Q 32 55, 18 48 Z"
        fill="#D4AF37"
      />
      <path
        d="M14 44 Q 32 58, 50 44 L 46 48 Q 32 55, 18 48 Z"
        fill="#800000"
        opacity="0.25"
      />
      {/* Diya rim highlight */}
      <path
        d="M15 44 Q 32 50, 49 44"
        fill="none"
        stroke="#FFE9AC"
        strokeWidth="1.2"
        strokeLinecap="round"
      />
    </svg>
  );
}

export function DivineCartLogo({ compact = false, className = "" }) {
  return (
    <div className={`flex items-center gap-2.5 ${className}`}>
      <DivineCartMark size={compact ? 36 : 44} />
      <div className="leading-none">
        <div className="font-serif tracking-tight text-primary" style={{ fontSize: compact ? "20px" : "24px", letterSpacing: "-0.02em" }}>
          Divine<span className="text-accent">Cart</span>
        </div>
        {!compact && (
          <div className="text-[9.5px] uppercase tracking-[0.32em] text-muted-foreground mt-1.5">
            Puja · Kits · Bhakti
          </div>
        )}
      </div>
    </div>
  );
}
